import { Form, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { InputNumber } from 'antd';
import orderApi from '../../apis/order';
import { IPrintArea, PrintAreaType } from '../../interfaces/Order';
import { ButtonGroupContainer, PageContainer } from '../../styles/Global';
import { $background } from '../../styles/Variables';
import CustomForm from '../Form/Form';
import CustomInput from '../Form/FormItem/Input/Input';
import PageHeader from '../PageHeader/PageHeader';
import PrimaryButton from '../PrimaryButton/PrimaryButton';

const ActionsStyled = styled.div`
  border-radius: 8px;
  background-color: ${$background};
  padding: 20px;
  width: 164px;
  position: sticky;
  top: 90px;
`;

const ActionsSyncStyled = styled(ActionsStyled)`
  top: 200px;

  .ant-btn-loading {
    &::before {
      display: none;
    }
  }
`;

const PrintAreaDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  const [printAreaData, setPrintAreaData] = useState<IPrintArea>({
    id: PrintAreaType.LeftChest,
    name: '',
    description: '',
    price: 0,
  });

  const fetchPrintArea = async (id: string) => {
    try {
      const result = await orderApi.getPrintAreaDetail(id);

      setPrintAreaData(result);
      form.setFieldsValue({
        name: result.name,
        price: result.price,
        description: result.description,
      });
    } catch (error) {
      navigate(-1);
      console.error(error);
    }
  };

  useEffect(() => {
    if (!!id) {
      fetchPrintArea(id);
    }
  }, []);

  const updatePrintArea = async () => {
    if (!id) {
      return;
    }

    try {
      setLoading(true);
      const { price, description, name } = form.getFieldsValue(true);

      const payload: IPrintArea = {
        id: printAreaData.id,
        price,
        description,
        name,
      };

      await orderApi.updatePrintArea(id, payload);
      message.success('Cập nhật vùng in thành công!');
      navigate(-1);
    } catch (e) {
      console.error(e);
      message.error('Cập nhật vùng in thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageContainer>
        <PageHeader title="Chi tiết vùng in" showBackButton />
        <div className="w-70">
          {/* <CustomPageHeader
            className="site-page-header p--0"
            title={id ? programInfoData.name : "New program"}
            onBack={() => navigate(-1)}
          /> */}

          <CustomForm
            form={form}
            initialValues={printAreaData}
            layout="vertical"
            scrollToFirstError
            requiredMark="optional"
            onFinish={() => {
              updatePrintArea();
            }}
          >
            <Form.Item
              name="id"
              label="Vùng in"
              rules={[
                {
                  required: true,
                  type: 'string',
                  message: 'Vui lòng chọn loại vùng in',
                },
              ]}
            >
              <Select
                options={Object.values(PrintAreaType).map((type) => ({
                  label: type,
                  value: type,
                }))}
                value={printAreaData.id}
                disabled
              />
            </Form.Item>
            <Form.Item
              name="price"
              label="Giá tiền"
              rules={[
                {
                  required: true,
                  type: 'number',
                  message: 'Vui lòng nhập giá tiền',
                },
              ]}
            >
              <InputNumber
                style={{ width: 200 }}
                placeholder="Giá tiền"
                formatter={(value) => {
                  if (!value) return '';
                  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                }}
                parser={(value) => {
                  if (!value) return '';
                  return value.replace(/,/g, '');
                }}
                addonAfter="VNĐ"
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Tên vùng in"
              rules={[
                {
                  required: true,
                  type: 'string',
                  message: 'Vui lòng nhập tên vùng in',
                },
              ]}
            >
              <CustomInput placeholder="Tên vùng in" />
            </Form.Item>
            <Form.Item
              name="description"
              label="Mô tả"
              rules={[
                {
                  type: 'string',
                },
                {
                  max: 255,
                  message: 'Mô tả không được dài quá 255 ký tự',
                },
              ]}
            >
              <CustomInput placeholder="Mô tả vùng in (Tùy chọn)" />
            </Form.Item>
            <Form.Item>
              <ButtonGroupContainer>
                <PrimaryButton htmlType="submit">Lưu</PrimaryButton>
              </ButtonGroupContainer>
            </Form.Item>
          </CustomForm>
        </div>

        {/* {!!id && (
          <div className="w-25 p__h--90">
            <ActionsStyled>
              <Button
                className="w-100 font-weight--300 bg--transparent border--none text-danger text-align--left p__v--4 p__h--11"
                icon={<DeleteOutlined className="font-size--16 p__r--8" />}
                type="text"
              >
                <span className="m__l--10 font-size--14">Remove</span>
              </Button>
            </ActionsStyled>
          </div>
        )} */}
      </PageContainer>
      {/* {showCancelConfirmationModal && (
        <BaseModal
          primaryBtn="Confirm"
          secondaryBtn="Cancel"
          // onPrimaryBtnClick={() => onCancel(true)}
          onSecondaryBtnClick={() => setShowCancelConfirmationModal(false)}
        >
          Quit editing? Changes you made so far will not be saved
        </BaseModal>
      )} */}
    </>
  );
};
export default PrintAreaDetail;
